var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.15 34.15C26.55 34.15 26.8917 34.0083 27.175 33.725C27.4583 33.4417 27.6 33.0833 27.6 32.65V15.35C27.6 14.9167 27.4583 14.5583 27.175 14.275C26.8917 13.9917 26.5333 13.85 26.1 13.85H21.9C21.5 13.85 21.1583 14 20.875 14.3C20.5917 14.6 20.45 14.95 20.45 15.35C20.45 15.7833 20.5917 16.1417 20.875 16.425C21.1583 16.7083 21.5167 16.85 21.95 16.85H24.6V32.7C24.6 33.1 24.75 33.4417 25.05 33.725C25.35 34.0083 25.7167 34.15 26.15 34.15ZM9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.23333 6.3 7.54167 6.9 6.925C7.5 6.30833 8.2 6 9 6H39C39.7667 6 40.4583 6.30833 41.075 6.925C41.6917 7.54167 42 8.23333 42 9V39C42 39.8 41.6917 40.5 41.075 41.1C40.4583 41.7 39.7667 42 39 42H9ZM9 39H39V9H9V39ZM9 9V39V9Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f1b9ab10f53941d8c075fd8f4ed43eb3.svg";
export { ForwardRef as ReactComponent };